(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sakinah-cart-drawer"]) return;
  try {
    
  (() => {
    const selector = '[data-sakinah-cart-drawer]';
    let previousFocus = null;
    let busy = false;
    let closeTimer = null;

    const drawer = () => document.querySelector(selector);
    const panel = () => drawer()?.querySelector('.sakinah-cart-drawer__panel');
    const cartRoot = () => window.Shopify?.routes?.root || '/';
    const normalisePath = (path) => path.replace(/\/+$/, '') || '/';
    const onCartPage = () => {
      const element = drawer();
      if (!element) return false;
      return normalisePath(window.location.pathname) === normalisePath(element.dataset.cartUrl || '/cart');
    };

    const setError = (message = '') => {
      const element = drawer()?.querySelector('[data-cart-drawer-error]');
      if (!element) return;
      element.textContent = message;
      element.hidden = !message;
    };

    const syncCartCount = () => {
      const element = drawer();
      if (!element) return;
      const count = Number(element.dataset.cartCount || 0);
      document.querySelectorAll('.cart-link').forEach((link) => {
        let badge = link.querySelector('span');
        if (count > 0) {
          if (!badge) {
            badge = document.createElement('span');
            link.append(badge);
          }
          badge.textContent = String(count);
          link.setAttribute('aria-label', element.dataset.cartLabel.replace('COUNT_TOKEN', String(count)));
        } else {
          badge?.remove();
          link.setAttribute('aria-label', element.dataset.cartEmptyLabel);
        }
      });
    };

    const openDrawer = (rememberFocus = true) => {
      const element = drawer();
      if (!element) return;
      window.clearTimeout(closeTimer);
      if (rememberFocus && !element.classList.contains('is-open')) previousFocus = document.activeElement;
      element.removeAttribute('inert');
      element.setAttribute('aria-hidden', 'false');
      element.classList.add('is-open');
      document.documentElement.classList.add('sakinah-drawer-open');
      window.requestAnimationFrame(() => panel()?.focus());
    };

    const closeDrawer = () => {
      const element = drawer();
      if (!element) return;
      element.classList.remove('is-open');
      element.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('sakinah-drawer-open');
      closeTimer = window.setTimeout(() => element.setAttribute('inert', ''), 330);
      if (previousFocus instanceof HTMLElement) previousFocus.focus();
    };

    const refreshDrawer = async (shouldOpen = true) => {
      const url = new URL(cartRoot(), window.location.origin);
      url.searchParams.set('section_id', 'sakinah-cart-drawer');
      url.searchParams.set('_', String(Date.now()));
      const response = await fetch(url, { headers: { Accept: 'text/html' }, cache: 'no-store' });
      if (!response.ok) throw new Error();
      const markup = await response.text();
      const parsed = new DOMParser().parseFromString(markup, 'text/html');
      const replacement = parsed.querySelector(selector);
      const current = drawer();
      if (!replacement || !current) throw new Error();
      current.replaceWith(replacement);
      syncCartCount();
      if (shouldOpen) openDrawer(false);
    };

    const request = async (url, options, trigger, onSuccess) => {
      if (busy) return;
      busy = true;
      setError();
      if (!drawer()?.classList.contains('is-open') && trigger instanceof HTMLElement) previousFocus = trigger;
      if (trigger) {
        trigger.disabled = true;
        trigger.setAttribute('aria-busy', 'true');
      }
      try {
        const response = await fetch(url, options);
        if (!response.ok) {
          const payload = await response.json().catch(() => ({}));
          throw new Error(payload.description || payload.message || '');
        }
        if (typeof onSuccess === 'function') onSuccess();
        if (onCartPage()) {
          window.location.reload();
          return;
        }
        await refreshDrawer(true);
      } catch (error) {
        const element = drawer();
        setError(error.message || element?.dataset.errorMessage || '');
        openDrawer(false);
      } finally {
        busy = false;
        if (trigger?.isConnected) {
          const productForm = trigger.closest('.product-form');
          const variantField = productForm?.querySelector('[data-product-variant]');
          const variantData = variantField?.tagName === 'SELECT' ? variantField.selectedOptions[0] : variantField;
          const productCanAdd = variantData?.dataset.available !== 'false';
          trigger.disabled = productForm ? !productCanAdd : false;
          trigger.removeAttribute('aria-busy');
        }
      }
    };

    document.addEventListener('click', (event) => {
      const close = event.target.closest('[data-cart-drawer-close]');
      if (close) {
        event.preventDefault();
        closeDrawer();
        return;
      }

      const change = event.target.closest('[data-cart-change]');
      if (change) {
        event.preventDefault();
        const element = drawer();
        const line = Number(change.dataset.line);
        const itemMessage = element?.querySelector(`[data-cart-item-message="${line}"]`);
        if (itemMessage) {
          itemMessage.textContent = '';
          itemMessage.hidden = true;
        }
        if (change.hasAttribute('data-cart-increase')) {
          const productQuantity = Math.max(0, Number(change.dataset.productQuantity || 0));
          const stockQuantity = Math.max(0, Number(change.dataset.stockQuantity || 0));
          const inventoryTracked = change.dataset.inventoryTracked === 'true';
          let message = '';
          if (productQuantity >= 5) message = element?.dataset.limitMessage || '';
          else if (inventoryTracked && Number(change.dataset.quantity) > stockQuantity) {
            message = stockQuantity > 0
              ? (element?.dataset.stockMessage || '').replace('COUNT_TOKEN', String(stockQuantity))
              : element?.dataset.stockNoneMessage || '';
          }
          if (message && itemMessage) {
            itemMessage.textContent = message;
            itemMessage.hidden = false;
            return;
          }
        }
        request(`${cartRoot()}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ line, quantity: Number(change.dataset.quantity) })
        }, change);
        return;
      }

      const cartLink = event.target.closest('.cart-link');
      if (cartLink && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
        event.preventDefault();
        openDrawer();
      }
    });

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.matches('form[action*="/cart/add"]') || event.defaultPrevented) return;
      if (onCartPage() && !form.closest(selector)) return;
      event.preventDefault();
      const button = event.submitter instanceof HTMLButtonElement ? event.submitter : form.querySelector('[type="submit"]');
      const updateProductLimit = () => {
        if (!form.matches('.product-form')) return;
        const variantField = form.querySelector('[data-product-variant]');
        const variantData = variantField?.tagName === 'SELECT' ? variantField.selectedOptions[0] : variantField;
        const quantity = Math.max(1, Number(new FormData(form).get('quantity') || 1));
        ['addLimit', 'productRemaining', 'stockRemaining'].forEach((key) => {
          if (variantData?.dataset[key] === undefined) return;
          variantData.dataset[key] = String(Math.max(0, Number(variantData.dataset[key]) - quantity));
        });
        variantField?.dispatchEvent(new Event('change', { bubbles: true }));
      };
      request(`${cartRoot()}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      }, button, updateProductLimit);
    });

    document.addEventListener('keydown', (event) => {
      const element = drawer();
      if (!element?.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeDrawer();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = [...panel().querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')].filter((item) => !item.hasAttribute('hidden'));
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    syncCartCount();
  })();

  } catch(e) { console.error(e); }
})();
})();
